import {CreateInstance} from './config'
const accessTicketAPI = CreateInstance('access_ticket_manage')
export default accessTicketAPI
